import { render, staticRenderFns } from "./SimulationDocuments.vue?vue&type=template&id=69785288&"
import script from "./SimulationDocuments.vue?vue&type=script&lang=js&"
export * from "./SimulationDocuments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports